import { defineGameCard, onAppear } from '../authoring/index.js';
import { photosynthesis } from './plant-helpers.js';
/**
 * Подсолнух-накопитель: Фотосинтез. Когда Подсолнух должен получить
 * положительный пакет Роста, он вместо этого передаёт весь пакет одному
 * случайному другому союзному Растению на поле (seeded, публичное
 * RandomUnitSelectionResolved показывает кандидатов и получателя). Если других
 * Растений нет, Рост остаётся на Подсолнухе. Перенаправление реализовано
 * публичным unit-scoped маркером, который читает общий addGrowth.
 */
export const GrowthSunflowerCard = defineGameCard({
    id: 'growth_sunflower',
    gameplay: {
        type: 'UNIT',
        cost: 2,
        baseStats: { attack: 1, health: 3 },
        traits: ['PLANT'],
    },
    presentation: {
        name: 'Подсолнух-накопитель',
        description: 'Фотосинтез. Когда Подсолнух должен получить Рост, весь пакет вместо этого передаётся одному случайному другому союзному Растению на поле. Если других Растений нет, Рост остаётся на Подсолнухе.',
        glyph: {
            colors: ['#10213A', '#FEC121', '#F68E0B', '#554120', '#B68C23'],
            rows: [
                '......11111111......',
                '....112322322211....',
                '...12233223233221...',
                '...12223333322221...',
                '..1332344444332331..',
                '.122234554454332221.',
                '.122334544444332221.',
                '..1223454444433221..',
                '...13344444443331...',
                '..1333344444533331..',
                '...11323333333211...',
                '....133333233331....',
                '....11133223111.....',
                '......131221........',
                '.......11111........',
                '..11...1144111...1..',
                '.145111445445511141.',
                '..1455455544555541..',
                '...14444554544441...',
                '....111145411111....',
            ],
        },
    },
    role: 'playable',
    abilities: [
        ...photosynthesis(),
        onAppear((ctx) => {
            if (ctx.self === undefined)
                return;
            ctx.ops.addEffect({
                defId: GrowthSunflowerCard.id,
                scope: { kind: 'unit', instanceId: ctx.self.id },
                sourceId: ctx.self.id,
                persistent: true,
                vars: { growthRedirect: true },
            });
        }),
    ],
    ui: {
        mechanics: ['growth', 'photosynthesis'],
        publicVars: { growthRedirect: { key: 'growthRedirect', kind: 'presence' } },
        effectStatusProviders: [(_context, effects) => effects.some((effect) => effect.facts.growthRedirect === true)
                ? [{
                        id: 'growth-sunflower',
                        symbol: '🌻',
                        label: effects.length === 1 ? 'Накопитель света' : `Накопитель света ×${effects.length}`,
                        description: 'Получаемый Рост передаётся одному случайному другому союзному Растению на поле.',
                        tone: 'neutral',
                        compact: true,
                    }]
                : []],
    },
});
//# sourceMappingURL=growth_sunflower.js.map